import React, { useState, useEffect } from "react";
import { styled } from "@mui/material/styles";
import { useDispatch, useSelector } from "react-redux";
import { Box, Dialog, DialogContent, Typography } from "@mui/material";

import HighlightOffRoundedIcon from "@mui/icons-material/HighlightOffRounded";

import ButtonBlue from "./ButtonBlue";

const StyledDialog = styled(Dialog)({
  "& .MuiDialogContent-root": {
    padding: 0,
    "& .content": {
      padding: 16,
      textAlign: "center",
      "& .delete-icon-label": {
        fontSize: 90,
        color: "#f15e5e",
      },
      "& .header-label": {
        padding: "20px 0",
      },
      "& .detail": {
        fontSize: 16,
        "& span": {
          color: "#f15e5e",
          fontSize: 20,
        },
      },
    },
  },
});

const DialogConfirmDelete = (props) => {
  const { open, handleClose, text, handleDelete, label, disabledBtnDelete } = props;
  return (
    <StyledDialog fullWidth maxWidth={"xs"} open={open} onClose={handleClose}>
      <DialogContent>
        <div
          style={{ width: "100%", height: 6, backgroundColor: "#f15e5e" }}
        ></div>
        <div className="content">
          <HighlightOffRoundedIcon className="delete-icon-label" />
          <Typography variant="h6" className="header-label" color="text.third">
            คุณแน่ใจใช่ไหม?
          </Typography>
          {label && (
            <Typography
              className="detail"
              variant="h6"
              color="text.secondary"
            >
              {label}
            </Typography>
          )}
          {text && (
            <Typography
              className="detail"
              variant="h6"
              style={{ color: "#f15e5e" }}
              component="span"
            >
              {text}
            </Typography>
          )}

          <Box
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "flex-end",
              marginTop: "20px",
            }}
          >
            <ButtonBlue
              color="secondary"
              variant="text"
              style={{ marginRight: "10px" }}
              onClick={handleClose}
            >
              ยกเลิก
            </ButtonBlue>
            <ButtonBlue
              color="error"
              variant="contained"
              onClick={handleDelete}
              disabledBtnDelete={disabledBtnDelete}
            >
              ยืนยันลบ
            </ButtonBlue>
          </Box>
        </div>
      </DialogContent>
    </StyledDialog>
  );
};

export default DialogConfirmDelete;
